(function () {
  if (window.__brInit) return;
  window.__brInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.br-reveal:not(.br-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('br-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('br-in');
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  // Respaldo: si el observador no avisa (pestana en segundo plano, navegador viejo),
  // se revisa a mano que no quede nada invisible dentro de la pantalla.
  function sweep() {
    var h = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.br-reveal:not(.br-in)').forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < h * 0.96 && r.bottom > 0) e.classList.add('br-in');
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    setTimeout(function () { ticking = false; sweep(); }, 120);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-br-product]').forEach(function (el) {
      if (el.__br) return;
      el.__br = true;
      var main = el.querySelector('[data-br-main]');
      var thumbs = el.querySelectorAll('[data-br-thumb]');
      var price = el.querySelector('[data-br-price]');
      var compare = el.querySelector('[data-br-compare]');
      var btn = el.querySelector('[data-br-add]');

      function show(url) {
        if (!main || !url) return;
        main.removeAttribute('srcset');
        main.src = url;
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t.getAttribute('data-full') === url ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-full')); });
      });

      el.querySelectorAll('input[type="radio"][name="id"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (price) price.innerHTML = r.getAttribute('data-price') || '';
          if (compare) compare.innerHTML = r.getAttribute('data-compare') || '';
          if (btn) {
            var ok = r.getAttribute('data-available') === 'true';
            btn.disabled = !ok;
            btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
          }
          show(r.getAttribute('data-img'));
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', r.value);
            window.history.replaceState({}, '', u.toString());
          } catch (e) {}
        });
      });
    });
  }

  function boot(root) { reveal(root); initProduct(root); setTimeout(sweep, 600); }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('visibilitychange', onScroll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
